export default "__VITE_ASSET__DM5DKIV1__"